import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import CommentIcon from '@mui/icons-material/Comment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WatchLaterIcon from '@mui/icons-material/WatchLater';

const Panels = ({ title, value, onClick, videoDetails, userDetails, type = 'default' }) => {
    const panelStyle = {
        backgroundColor: 'var(--primary-color)', 
        borderRadius: '10px',
       /* padding: '20px',*/
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: type === 'video' || type === 'user' ? 'left' : 'center',
        cursor: 'pointer',
        position: 'relative',
        width: type === 'video' || type === 'user' ? '100%' : 'auto',
        maxWidth: type === 'video' || type === 'user' ? '700px' : '300px',
        /*minHeight: type === 'video' ? 'auto' : '150px',*/
        display: 'flex',
        flexDirection: type === 'video' || type === 'user' ? 'row' : 'column',
        alignItems: 'center',
        gap: '20px',
        justifyContent: 'center', // Align elements to the left
        overflow: 'hidden',
        marginLeft: 0, 
    };

    const iconStyle = {
        fontSize: '25px',
        marginRight: '5px',
    };

    const textStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        marginLeft: '10px',
        marginRight: '10px',
    };

    const subTextStyle = {
        fontSize: '16px',
        textAlign: 'center',
    };

    const statsStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: '10px',
        fontSize: '20px',
    };

    const arrowIconStyle = {
        fontSize: '25px',
        color: 'var(--primary-white-color)',
    };

    return (
        <div style={panelStyle} onClick={onClick}>
            {type === 'video' && videoDetails ? (
                <>
                    <img
                        src={videoDetails.thumbnail}
                        alt={`${videoDetails.title} Thumbnail`}
                        style={{
                            width: '150px',
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: '5px',
                        }}
                    />
                    <div style={{ flex: 1, color: 'var(--primary-white-color)', }}>
                        <p style={textStyle}>{videoDetails.title}</p>
                        <p style={subTextStyle}>ID: <strong>{videoDetails.id}</strong></p>
                        <div style={statsStyle}>
                            <span>
                                <ThumbUpIcon style={iconStyle} />
                                <strong>{videoDetails.totalLikes || 0}</strong>
                            </span>
                            <span>
                                <CommentIcon style={iconStyle} />
                                <strong>{videoDetails.totalComments || 0}</strong>
                            </span>
                            <span>
                                <VisibilityIcon style={iconStyle} />
                                <strong>{videoDetails.totalViews || 0}</strong>
                            </span>
                            <span>
                                <WatchLaterIcon style={iconStyle} />
                                <strong>{`${videoDetails.averageWatchtime.toFixed(2)}%` || 0}</strong>
                            </span>
                        </div>
                    </div>
                    <ArrowForwardIosIcon style={arrowIconStyle} />
                </>
            ) : type === 'user' && userDetails ? (
                <>
                    <img
                        src={userDetails.avatarIcon}
                        alt="User Avatar"
                        style={{
                            width: '50px',
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: '50%',
                            border: '3px solid white',
                        }}
                    />
                    <div style={{ flex: 1, color: 'var(--primary-white-color)', }}>
                        <p style={textStyle}>{userDetails.userName}</p>
                        <div style={statsStyle}>
                            <span>
                                <VisibilityIcon style={iconStyle} />
                                <strong style={{fontSize: '16px'}}>{userDetails.totalViews || 0}</strong>
                            </span>
                            <span>
                                <WatchLaterIcon style={iconStyle} />
                                <strong style={{fontSize: '16px'}}>{`${userDetails.averageWatchtime}%` || 0}</strong>
                            </span>
                            <span>
                                <ThumbUpIcon style={iconStyle} />
                                <strong style={{fontSize: '16px'}}>{userDetails.totalLikes || 0}</strong>
                            </span>
                            <span>
                                <CommentIcon style={iconStyle} />
                                <strong style={{fontSize: '16px'}}>{userDetails.totalComments || 0}</strong>
                            </span>
                        </div>
                    </div>
                    <ArrowForwardIosIcon style={arrowIconStyle} />
                </>
            ) : (
                <>
                    <p style={textStyle}>{title}</p>
                    <p style={subTextStyle}> <strong>{value}</strong></p>
                </>
            )}
        </div>
    );
};

export default Panels;
